














































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Regulation } from '@/class/room'
import InTownRoleGuideViewer from '@/components/InTownRoleGuideViewer.vue'

@Component({
  components: {
    InTownRoleGuideViewer
  }
})
export default class RegulationViewer extends Vue {
  @Prop() data!: Regulation;

  get inTownRoleData () {
    return {
      playersCount: this.data.playersCount,
      mustUseRoles: this.data.settings.mustUseRoles,
      randomUseRoles: this.data.settings.randomUseRoles,
      roleSettings: this.data.settings.roleSettings
    }
  }

  get settings () {
    return this.data.settings
  }
}
